import React from 'react';
import { PreviewTab } from './PreviewTab';

export function PreviewTabs({ tabs }) {
  return tabs?.length > 0 ? (
    <>{tabs?.map(tab => <PreviewTab key={tab.uri} tab={tab} />)}</>
  ) : null;
}
